import fetcher from 'api/fetcher';
import { MagritteNotificationName } from 'utils/constants/notification';
import { RequisiteError, RequisiteErrorType } from 'utils/constants/requisites';

import employerRequisitesFormSubmit from '@hh.ru/analytics-js-events/build/clickme/employer/header/profile/employer_requisites_form_submit';

import { requisitesFormToDto, SaveRequisitesData } from 'components/RequisitesFormModal/requisitesMapper';

import { addMagritteNotification } from 'store/models/notification';
import {
    RequisitesErrors,
    setAllRequisitesErrors,
    setRequisitesFilled,
    setRequisitesFormOpen,
    setRequisitesPayers,
} from 'store/models/requisites';
import { AppThunkAction } from 'store/utils';

interface Error {
    response?: {
        data: {
            errors: {
                key: RequisiteError;
                location: string | null;
            }[];
        };
        status: number;
    };
}

type SaveRequisites = (
    setSaving: (isSaving: boolean) => void,
    callback?: () => void
) => AppThunkAction<Promise<void> | null>;

export const saveRequisites: SaveRequisites = (setSaving, callback) => {
    return (dispatch, getState) => {
        const state = getState();
        const requisites = state.requisites.requisites;
        const body: SaveRequisitesData = requisitesFormToDto(requisites);

        setSaving(true);
        return fetcher
            .post('/api/v1/requisites', body)
            .then(() => {
                employerRequisitesFormSubmit();
                dispatch([
                    setRequisitesPayers([]),
                    setRequisitesFormOpen(false),
                    setRequisitesFilled(true),
                    addMagritteNotification(MagritteNotificationName.RequisitesSaveSuccess),
                ]);
                callback?.();
            })
            .catch((err: Error) => {
                const status = err?.response?.status;
                const data = err.response?.data;
                const errors: RequisitesErrors = {};

                if (data) {
                    const errorsForAnalytics: Record<string, string>[] = [];
                    data.errors.forEach(({ location, key }, index) => {
                        if (!location) location = RequisiteErrorType.COMMON;
                        errors[location] = key;
                        errorsForAnalytics[index] = { field: location, description: key };
                    });
                    employerRequisitesFormSubmit({ errors: JSON.stringify(errorsForAnalytics) });
                }

                if (status === 400 && data) {
                    dispatch([
                        setAllRequisitesErrors(errors),
                        addMagritteNotification(MagritteNotificationName.RequisitesFormValidationError),
                    ]);
                }

                if (status === 403) {
                    dispatch(addMagritteNotification(MagritteNotificationName.RequisitesSaveForbiddenError));
                }
            })
            .finally(() => setSaving(false));
    };
};
